import Cookies from 'js-cookie';

const url=process.env.REACT_APP_ENV==="production"?"https://hrmanagement.zorvas.com":process.env.REACT_APP_API_URL

async function SendVideo(video){

    // const videoURL=URL.createObjectURL(video)
    const formData=new FormData();
    formData.append('audio',video,'audio.mp3');


    try{
        const response =await fetch(`${url}/api/ai/pyschotest`,{method:'POST',
            headers: {
              'Authorization': `Bearer ${Cookies.get('token') || ''}`, 
            },body:formData});
    
            if(response.ok)
            {
                const data=await response.json();
                // console.log(data);
                return data;
            }
    }
    catch(error){
         return error;
    }
   
}

export {SendVideo};